export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'blur' },
    ],
    state_id: [
        { required: true, message: 'Пожалуйста, выберите страна', trigger: 'blur' },
    ],
};
